export default {
  setAdditionalFieldsTypes(state, payload) {
    state.additionalFieldsTypes = payload
  },
}